(function () {
  'use strict';

  angular.module('ringbaPortal').component('inAppNotificationsDashboard', {
    controller: InAppNotificationsDashboardController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/in-app-notifications/in-app-notifications-dashboard.view.html'
  });

  function InAppNotificationsDashboardController(
    notificationService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.markAllAsRead = markAllAsRead;


    function onInit() {
      vm.notificationSharedObject = notificationService.sharedNotificationObject;
    }

    async function markAllAsRead() {
      // get preview total count and unread count aren't reliable values; API doesn't return counts respecting the 12 month expiration of messages in AeroSpike db
      // so we get all unread messages first before calling this function
      await notificationService.getAllUnreadMessages();
      await notificationService.markAllAsRead();
    }
  }

})();
